@if (priceFactors.length > 0) {
	<nb-card class="offer-request-card">
		<nb-card-body class="overflow-visible">
			<form [formGroup]="form">
				@for (priceFactor of priceFactors; track trackByPriceFactorFn($index, priceFactor); let isLast = $last) {
					<div class="form-row price-factors">
						<div class="radio-button-group">
							<nb-radio-group [id]="'price-factor-' + priceFactor.type.toLowerCase() + '-' + product.standard.name.toLowerCase()" [name]="priceFactor.type"
											[formControlName]="priceFactor.type + getFormKey()" [attr.formcontrolname]="priceFactor.type + getFormKey()"
											[status]="isInvalid(priceFactor.type) ? 'danger' : 'primary'" [disabled]="shouldDisableRadio(priceFactor.type)"
											(valueChange)="updateFormControl(priceFactor.type, $event)">
								<nb-radio name="yes" [value]="true">{{ 'common.yes' | translate }}</nb-radio>
								<nb-radio name="no" [value]="false">{{ 'common.no' | translate }}</nb-radio>
							</nb-radio-group>
						</div>
						<div class="price-factor-name">
							{{ priceFactor.question }}
						</div>
					</div>
					@for (attachedQuestion of priceFactor.attachedQuestions; track trackByPriceFactorFn($index, attachedQuestion)) {
						@if (attachedQuestionVisible(attachedQuestion, priceFactor.type) && attachedQuestion.questionType == TEXT) {
							<input
								class="text-attached-question"
								[id]="'attached-question-' + priceFactor.type.toLowerCase() + '-' + product.standard.name.toLowerCase() + '-' + attachedQuestion.type.toLowerCase()"
								[formControlName]="priceFactor.type + '-' + attachedQuestion.type + getFormKey()" [attr.formcontrolname]="priceFactor.type + '-' + attachedQuestion.type + getFormKey()"
								[name]="priceFactor.type + '-' + attachedQuestion.type"
								[placeholder]="attachedQuestion.question" type="text" nbInput fullWidth autocomplete="user-password">
						}
						@if (isAttachedQuestionInvalid(priceFactor.type, attachedQuestion.type)) {
							<div class="validation-message">{{ getAttachedQuestionErrors(priceFactor.type, attachedQuestion.type)  | async }}</div>
						}
						@if (translationExists(priceFactor.type, attachedQuestion.type)) {
							<translation-field [standard]="product.standard.name"
											   [translationSubject]="translationSubject(priceFactor.type, attachedQuestion.type)"
											   [translatedText]="getTranslationText(priceFactor.type, attachedQuestion.type)"
											   [previewMode]="true"></translation-field>
						}
					}
					<div class="separator" [ngClass]="{'last': isLast}"></div>
				}
				@if (anyPriceFactorInvalid()) {
					<div class="validation-message">{{ 'validations.all-answers-required' | translate }}</div>
				}
			</form>
		</nb-card-body>
	</nb-card>
}
